import { ReactNode, useEffect } from 'react';
import { useAuth } from 'hooks/Auth';
import { useTranslation } from 'react-i18next';

// Material UI Components
import LinearProgress from '@mui/material/LinearProgress';

// Project Components
import Footer from 'components/navigation/Footer';
import TopBar from './TopBar';
import SkipToContent from 'components/navigation/SkipToContent';

export type NavigationProps = {
  children?: ReactNode;
  isLoading?: boolean;
  header?: string;
  noFooter?: boolean;
  paddingOnSmall?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
};

const Navigation = ({ children, isLoading, noFooter, paddingOnSmall, header }: NavigationProps) => {
  const [auth, isAuthLoading] = useAuth();
  const { t } = useTranslation(['events']);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SkipToContent />
      <TopBar />
      <main id={'main'} style={{ minHeight: '101vh' }}>
        <>{isLoading ? <LinearProgress /> : <>{children}</>}</>
      </main>
      {!noFooter && !isLoading && <Footer />}
    </>
  );
};

export default Navigation;
